import {getHttpRequestNoAuth, putHttpRequestNoAuth} from '@/utils/HttpRequests';
import axios from 'axios';
import { isBase64Image } from '@/utils/CommonHelper';

export async function getBuildingsApi() {
    try {
        const result = await getHttpRequestNoAuth(`buildings`)
        // return array of buildings
        return [...result]
    } catch (err) {
        console.error('[backendApiService] getBuildingsApi Error', err);
    }
}

export async function getSiteMeterReadsApi() {
    try {
        const result = await getHttpRequestNoAuth(`site-meter-reads`);
        return [...result];
    } catch (err) {
        console.error('[backendApiService] getSiteMeterReadsApi Error', err);
    }
}

export async function saveSiteMeterReadApi(payload) {
    let formData = new FormData();
    formData.append("meterId", payload.meterId);
    formData.append("buildingId", payload.buildingId);
    formData.append("readSequence", payload.readSequence);
    formData.append("meterRead", payload.meterRead);
    formData.append("meterReadDate", payload.meterReadDate);
    formData.append("meterNotes", payload.meterNotes ?? "");
    formData.append("imagePath", payload.imagePath ?? "");

    if (isBase64Image(payload.imageOrUrl)) {
        formData.append("meterReadImage", payload.imageOrUrl);
    }

    try {
        const response = await axios.put(`/site-meter-reads/${payload.meterId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            console.error('[backendApiService] saveSiteMeterReadApi Not Found', err);
            return;
        }
        console.error('[backendApiService] saveSiteMeterReadApi Error', err);
        throw err;
    }
}

export async function getImageFileUrl(filePath) {
    const encodedFilePath = encodeURIComponent(filePath);
    try {
        const response = await axios.get(`/image-url?filePath=${encodedFilePath}`);
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 404) {
            console.error('[backendApiService] getMeterReadImage Not Found', err);
            return;
        }
        console.error('[backendApiService] getMeterReadImage Error', err);
        throw err;
    }
}

export async function getSiteMeterReadsByBuildingApi(buildingId) {
    try {
        const result = await getHttpRequestNoAuth(`buildings/${buildingId}/reads`);
        return [...result];
    } catch (err) {
        console.error('[backendApiService] getSiteMeterReadsByBuildingApi Error', err);
    }
}

export async function submitBuildingReadsApi(buildingId) {
    try {
        await putHttpRequestNoAuth(`buildings/${buildingId}/submit`, null);
    }
    catch (err) {
        if (err.response.status === 404)
        {
            console.error('[backendApiService] submitBuildingReadsApi Not Found', err);
            return;
        }
        console.error('[backendApiService] submitBuildingReadsApi Error', err);
        throw err;
    }
}